exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-23014e60]{margin-bottom:14px;color:#303133;font-weight:500;font-size:14px}.description-term[data-v-23014e60]{display:table-cell;padding-bottom:5px;line-height:20px;width:50%;font-size:12px;color:#606266}.description[data-v-23014e60]  .el-divider--horizontal{margin:12px 0 !important}.el-form[data-v-23014e60]{margin-top:20px}[data-v-23014e60] .dialog-footer .el-button{-webkit-transition:all .3s;transition:all .3s}", ""]);

// exports
